<script lang="ts">
    

    interface Props {
        // number = % width, '-' = par sep, anything else ('x' for example) = full block line
        pattern?: Array<string | number | FlexLine> | undefined;
        style?: string | undefined | null;
    }

    let { pattern = undefined, style = undefined }: Props = $props();

    // flexline: the line is 100% width
    // each item MUST follow the pattern <t|b>:<flex value>
    type FlexLine = ['flex', string[]]
</script>

{#if pattern && pattern.length}
    <div class="animated-loading" {style}>
        {#each pattern as pattern}
            {#if pattern === '-'}
                <div class="text-line-sep"></div>
            {:else if Array.isArray(pattern)}
                <div class="flex-line">
                    {#each pattern[1] as fb}
                        {#if fb[0] == '-'}
                            <div class="empty-line" style="flex: {fb.slice(2)}"></div>
                        {:else if fb[0] == 'b'}
                            <div class="button-line" style="flex: {fb.slice(2)}">
                                <div class="text-line"></div>
                            </div>
                        {:else}
                            <div class="text-line" style="flex: {fb.slice(2)}"></div>
                        {/if}
                    {/each}
                </div>
            {:else if typeof pattern == 'number'}
                <div class="text-line" style="max-width: {pattern}%"></div>
            {:else if pattern.match(/^>\d+$/)}
                <div style="display: block; text-align: right">
                    <div class="text-line" style="max-width: {parseInt(pattern.slice(1), 10)}%"></div>
                </div>
            {:else if pattern.match(/^\d/)}
                <div class="text-line" style="max-width: {pattern}"></div>
            {:else}
                <div class="text-line"></div>
            {/if}
        {/each}
    </div>
{/if}
